import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/reviews/line-bottom.gif")